import { createSlice } from "@reduxjs/toolkit";

const initialFilterState = {
  selectedFilter: "",
  filters: [],
  parksDef: [],
  parksFilter: [],
  images: [],
  imagesId: [],
  touched: false,
};

const filterSlice = createSlice({
  name: "filter",
  initialState: initialFilterState,
  reducers: {
    defaultValues(state, action) {
      
      if (action.payload.method === "filter") {
        state.filters = action.payload.values;
      } else if (action.payload.method === "park") {
        state.parksDef = action.payload.values;
        state.parksFilter = action.payload.values;
        
      }
      else if(action.payload.method === "image"){
        state.images = action.payload.values;
      }
      else if(action.payload.method === "imageId"){
        state.imagesId = action.payload.values;
        
      }
    },

    filterSelected(state, action) {
      const method = action.payload.method;

      switch (method) {
        case "selected":
          state.touched = true;
          state.parksFilter = state.parksDef.filter((value) => {
            return value.region === action.payload.value;
          });
          break;
        case "clear":
          state.touched = false;
          state.parksFilter = state.parksDef;
          break;

        case "bySearchBar":
          state.parksFilter = state.parksDef.filter((value) =>
            String(value["nombre"])
              .normalize("NFD")
              .replace(/\p{Diacritic}/gu, "")
              .toLowerCase()
              .includes(action.payload.value.toLowerCase())
          );
          break;
        default:
          break;
      }
    },
    toReset(state) {
      Object.assign(state, initialFilterState);
    },
  },
});

export const filterActions = filterSlice.actions;
export default filterSlice.reducer;
